<?xml version="1.0" encoding="UTF-8"?>
<svg id="aST" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17.36 21.91">
    <defs>
        <style>.cST{fill:#2684ff;}.dST{fill:url(#bST);}</style>
        <linearGradient id="bST" x1="12.1244" y1="-802.5811" x2="12.1244" y2="-795.2291"
                        gradientTransform="translate(0 -788.1102) scale(1 -1)" gradientUnits="userSpaceOnUse">
            <stop offset=".18" stop-color="#0052cc"/>
            <stop offset="1" stop-color="#2684ff"/>
        </linearGradient>
    </defs>
    <path class="cST"
          d="M15.624,9.135c0-3.808-3.08-6.944-6.944-6.944-3.808,0-6.944,3.08-6.944,6.944,0,3.08,2.016,5.656,4.76,6.608v3.472c0,.28,.224,.504,.504,.504h3.304c.28,0,.504-.224,.504-.504v-3.472c2.8-.896,4.816-3.528,4.816-6.608Zm-6.944,2.352c-1.288,0-2.352-1.064-2.352-2.352s1.064-2.352,2.352-2.352,2.352,1.064,2.352,2.352-1.064,2.352-2.352,2.352Z"/>
    <path class="dST"
          d="M8.68,2.191V6.783c1.288,0,2.352,1.064,2.352,2.352s-1.064,2.352-2.352,2.352c1.176,0,2.128,.952,2.128,2.128v2.072c2.744-.896,4.76-3.528,4.76-6.608,.056-3.752-3.08-6.888-6.888-6.888Z"/>
</svg>